import { Rpc } from '../rpc';
import { RpcOutbound } from '../rpc-outbound';
import { RpcOutboundClient } from '../rpc-outbound-client';
import { RpcSmeExtensionRequestResult, RpcSmeExtensionResponseKey, RpcSmeExtensionUpdateStatus } from './rpc-sme-extension-model';

export class RpcSmeExtensionResponseClient {
    /**
     * Get sme extensions response client call.
     *
     * @param rpc the rpc service.
     * @param data the extension object or status data.
     * @param outbound the outbound channel to call. @optional
     * @return Promise<void> the promise object.
     */
    public static getExtensionsResponse(rpc: Rpc, data: RpcSmeExtensionRequestResult | RpcSmeExtensionUpdateStatus): Promise<void>;
    public static getExtensionsResponse
        (rpc: Rpc, data: RpcSmeExtensionRequestResult | RpcSmeExtensionUpdateStatus, outbound?: RpcOutbound): Promise<void>;
    public static getExtensionsResponse(
        rpc: Rpc,
        data: RpcSmeExtensionRequestResult | RpcSmeExtensionUpdateStatus,
        outbound?: RpcOutbound): Promise<void> {
        if (outbound) {
            return RpcOutboundClient.callOutbound(
                rpc.rpcManager.rpcChannel,
                outbound,
                RpcSmeExtensionResponseKey.command,
                RpcSmeExtensionResponseKey.version,
                data
            );
        } else {
            return RpcOutboundClient.call(rpc, RpcSmeExtensionResponseKey.command, RpcSmeExtensionResponseKey.version, data);
        }
    }
}
